/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Faq_A1Inputs */

const en_fw_faq_a1 = /** @type {(inputs: Fw_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outside Asia, Crunchyroll simulcasts it with subtitles. In Japan it airs Fridays at 23:30 JST on Fuji TV’s Noitamina block and streams on Japanese services from midnight. Muse Communication holds the Southeast Asia license.`)
};

const zh_fw_faq_a1 = /** @type {(inputs: Fw_Faq_A1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`亚洲以外由 Crunchyroll 字幕同步播出；日本每周五 23:30 在富士电视台ノイタミナ档首播，午夜起在日本各流媒体上线；东南亚由木棉花（Muse Communication）代理。`)
};

/**
* | output |
* | --- |
* | "Outside Asia, Crunchyroll simulcasts it with subtitles. In Japan it airs Fridays at 23:30 JST on Fuji TV’s Noitamina block and streams on Japanese services f..." |
*
* @param {Fw_Faq_A1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_faq_a1 = /** @type {((inputs?: Fw_Faq_A1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Faq_A1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_faq_a1(inputs)
	return zh_fw_faq_a1(inputs)
});
export { fw_faq_a1 as "fw.faq.a1" }